import { useEffect, useRef } from "react";
import { useInterview } from "../../contexts/interview.context";

const VideoPreview = () => {
  const { videoRef, isVideoOff } = useInterview().interview;
  const streamRef = useRef<MediaStream | null>(null);
  // Start the webcam and attach to videoRef
  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
    }
  };

  // Stop the webcam and release the stream
  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  // Mount: start camera unless video is turned off
  useEffect(() => {
    if (!isVideoOff) {
      startCamera();
    }

    return () => {
      stopCamera(); // Cleanup on unmount
    };
  }, []);

  // Watch for isVideoOff toggle
  useEffect(() => {
    if (isVideoOff) {
      stopCamera();
    } else {
      startCamera();
    }
  }, [isVideoOff]);


  return (
    <div className="p-2 relative smp-4 bg-transparent w-full h-[98%] max-w-xs min-w-[300px] max-h-[25vh] lg:max-h-[30vh] lg:max-w-[400px] aspect-video shadow-md flex flex-col items-center rounded-xl ">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        onContextMenu={(e) => e.preventDefault()} // Prevent right-click context menu
        className="w-full h-full object-center object-cover  rounded-md"
      />
    </div>
  );
};

export default VideoPreview;
